import React from "react";

export const ShimmerBlock: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div
    className={`bg-slate-200 animate-shimmer bg-[linear-gradient(90deg,#ececec,#f5f5f5,#ececec)] bg-[length:1000px_100%] rounded ${className}`}
    aria-hidden="true"
  />
);

export const StatCardSkeleton: React.FC = () => (
  <div className="bg-white rounded-xl shadow-soft border border-slate-200 p-4 sm:p-5 lg:p-6 transition-all duration-300 group">
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between h-full">
      <div className="flex-1 min-w-0 mb-3 sm:mb-0 pr-2 space-y-4 card-content">
        <ShimmerBlock className="w-28 h-5" />
        <ShimmerBlock className="w-12 h-10" />
      </div>
      <ShimmerBlock className="w-8 h-8 rounded-lg flex-shrink-0" />
    </div>
  </div>
);

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 5,
  columns = 4,
}) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden w-full">
    <div
      className="hidden md:grid gap-4 px-6 py-4 border-b border-gray-200 bg-gray-50"
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {Array.from({ length: columns }).map((_, i) => (
        <ShimmerBlock key={i} className="h-4 w-24" />
      ))}
    </div>
    <div className="divide-y divide-gray-100">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="grid gap-4 py-4 px-6 items-center"
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <ShimmerBlock key={colIndex} className="h-4 w-full" />
          ))}
        </div>
      ))}
    </div>
    <div className="px-6 py-4 flex justify-between items-center border-t border-gray-200">
      <ShimmerBlock className="h-6 w-32" />
      <div className="flex gap-4">
        <ShimmerBlock className="h-8 w-16" />
        <ShimmerBlock className="h-8 w-24" />
      </div>
    </div>
  </div>
);
